import Vue from 'vue'
import eventHub from '../helpers/event-hub'

if (document.getElementById('vue-header')) {

  const informations = JSON.parse(document.getElementById('cp_recrutement_json').innerText)
  const employer = informations.page_types.find(item => item.value === true);
  const candidate = informations.page_types.find(item => item.value === false);
  const page_type = informations.page_type;
  const main_url_employer = informations.main_url_employer;
  const main_url_candidate = informations.main_url_candidate;
  const related_page = informations.related_page;

  new Vue({
    el: '#vue-header',
    data() {
      return {
        isOpenMenu: false,
        menuLabel: 'Menu',
        checkbox: {
          value: page_type,
          checkedLabel: employer.label,
          uncheckedLabel: candidate.label
        },
      }
    },
    mounted() {
      window.addEventListener('DOMContentLoaded', function() {
        const ctas_job_ad = document.querySelectorAll('.js-job-ad'),
              ctas_job_application = document.querySelectorAll('.js-job-application'),
              ctas_meeting = document.querySelectorAll('.js-meet');
      
        if(ctas_job_ad) {
          ctas_job_ad.forEach((cta) => {
            cta.addEventListener('click', function() {
              // eventHub.$emit('tabindexchange', 0)
              eventHub.$emit('modal:employer:open')
            });
          })
        }
      
        if (ctas_job_application) {
          ctas_job_application.forEach((cta) => {
            cta.addEventListener('click', function() {
              eventHub.$emit('modal:candidate:open')
            });
          })
        }
      
        if (ctas_meeting) {
          ctas_meeting.forEach((cta) => {
            cta.addEventListener('click', function() {
              eventHub.$emit('tabindexchange', 0)
              // eventHub.$emit('tabindexchange', 1)
              eventHub.$emit('modal:employer:open')          
            });
          });
        }
      });
    },
    created () {
      eventHub.$on(`footer-switch`, (event) => {
        this.checkbox.value = event
      }),
      eventHub.$on(`main-switch`, (event) => {
        this.checkbox.value = event
      })
    },
    methods: {
      onChange(event) {
        eventHub.$emit('header-switch', event);
        let url;
        if (related_page) {
          url = related_page
        } else {
          url = this.checkbox.value === true ?  main_url_candidate : main_url_employer;
        }
        window.open(url, '_self');
      },

      toogleMenu() {
        this.isOpenMenu = !this.isOpenMenu
        if (this.isOpenMenu === true) {
          document.querySelector('body').style.overflow = 'hidden';
        } else {
          document.querySelector('body').style.overflow = 'auto';
        }
        this.menuLabel = this.isOpenMenu === true ? 'Fermer' : 'Menu';
      }
    }
  })
}